<div *ngIf="project | async as project">
    <span class="v1-link" title="{{ project.platformName }}">
        <a [routerLink]="'/cloud/projects'">
            <i class="fal fa-clouds" aria-hidden="true">
            </i>&nbsp;&nbsp;&nbsp;&nbsp;<span>{{ project.platformName }}</span>
        </a>
    </span>
    &nbsp;&nbsp;
    <span class="v1-link" title="{{ project.projectName }}">
        <a [routerLink]="'/cloud/projects'">
            <i class="fal fa-box" aria-hidden="true">
            </i>&nbsp;&nbsp;&nbsp;&nbsp;<span>{{ project.projectDescription }}</span>
        </a>
    </span>
</div>
